<div class="workspace no-back-btn">
  <div class="d-flex flex-column">
    <div class="flex-g1">
      <div class="d-flex flex-column flex-auto" id="campaigns-management">
        <div class="campaigns-breadcumb d-none d-md-block">
          <div class="d-flex flex-row flex-auto breadcumb-container">
            <div class="d-flex flex-g2 align-items-center">
              <div class="d-flex flex-column flex-auto justify-content-start">
                <div class="d-flex flex-g1 align-items-center breadcumb-header">
                  <a class="not-underline first-line text-semi-bold-font">
                    {{campaignBreadcrumbRoot | translate}}
                  </a>
                </div>
                <div class="d-flex flex-g1 breadcumb-subheader">
                  {{campaignreadcrumbSubtitle | translate}}
                </div>
              </div>
            </div>
            <div class="d-flex flex-g1">
              <div class="d-flex flex-row flex-auto align-items-center justify-content-end">
                <div class="search-box-container">
                  <achoo-text-field [model]="currentSearchValue" [placeholder]="'common.search' | translate" 
                                    [isPageSearch]="true" (modelChange)="onSearchChange($event)">
                  </achoo-text-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="campaigns-dislay-list">
          <div class="d-none d-md-flex flex-row flex-auto">
            <div class="d-flex flex-g1 campaigns-header">
              <div class="d-flex flex-row flex-auto flex-nowrap">
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-info">
                  <span>{{'campaigns.name-and-description' | translate}}</span>
                </div>
                <div *ngIf="!enableInfluencerPlatform" class="d-flex header-title campaign-overview-header align-items-center campaign-total-influencers">
                  <span>{{'campaigns.influencers' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.num_of_infl' | translate"></achoo-icon-tooltip>
                </div>
                <div *ngIf="enableInfluencerPlatform" class="d-flex header-title campaign-overview-header align-items-center campaign-total-influencers">
                  <span>{{'campaigns.status' | translate}}</span>
                </div>
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-total-posts">
                  <span>{{'campaigns.posts' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.num_of_post' | translate"></achoo-icon-tooltip>
                </div>
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-reach">
                  <span>{{'campaigns.reach' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.reach' | translate"></achoo-icon-tooltip>
                </div>
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-engagement">
                  <span>{{'campaigns.engagement' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.engagement' | translate"></achoo-icon-tooltip>
                </div>
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-impact-percent">
                  <span>{{'campaigns.impact' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.impact' | translate"></achoo-icon-tooltip>
                </div>
                <div class="d-flex header-title campaign-overview-header align-items-center campaign-button-group">
                  <span>{{'campaigns.actions' | translate}}</span>
                  <achoo-icon-tooltip *ngIf="!enableInfluencerPlatform" [tooltipMsg]="'info_box.campaign.action_buttons' | translate"></achoo-icon-tooltip>
                </div>
              </div>
            </div>
          </div>
          <achoo-placeholder [placeholderId]="'campaignListHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
            <ng-container *ngIf="!isSearching">
              <div *ngIf="isSearchResultEmpty" class="empty-result-message-container">
                <span>{{'campaigns.campaign_search_empty' | translate}}</span>
              </div>
              <ng-container *ngIf="!isSearchResultEmpty">
                <div class="campaign-group" *ngIf="invitesCampaignList.length">
                  <div class="group-title d-block d-md-none">
                    <div class="title">{{'campaigns.campaign_invites' | translate}}</div>
                  </div>
                  <campaign-item *ngFor="let campaign of invitesCampaignList"
                    [campaign]="campaign"
                    [enableInfluencerPlatform]="enableInfluencerPlatform"
                    (eventSelectCampaign)="onSelectCampaign($event)"
                    (eventDeleteCampaign)="showWarningDeleteCampaignPopup($event)"
                    (eventOpenAddInfluencer)="openAddInfluencer($event)"
                    (eventOpenMeasurePage)="openMeasurePage($event)"
                    (goToCampaignDetails)="goToCampaignDetails(campaign.id)">
                  </campaign-item>
                </div>
                <div class="campaign-group" *ngIf="activesCampaignList.length">
                  <div class="group-title d-block d-md-none">
                    <div class="title">{{'campaigns.active_campaigns' | translate}}</div>
                  </div>
                  <campaign-item *ngFor="let campaign of activesCampaignList"
                    [campaign]="campaign"
                    [enableInfluencerPlatform]="enableInfluencerPlatform"
                    (eventSelectCampaign)="onSelectCampaign($event)"
                    (eventDeleteCampaign)="showWarningDeleteCampaignPopup($event)"
                    (eventOpenAddInfluencer)="openAddInfluencer($event)"
                    (eventOpenMeasurePage)="openMeasurePage($event)"
                    (goToCampaignDetails)="goToCampaignDetails(campaign.id)">
                  </campaign-item>
                </div>
                <div class="campaign-group" *ngIf="historiesCampaignList.length">
                  <div class="group-title d-block d-md-none">
                    <div class="title">{{'campaigns.campaign_history' | translate}}</div>
                  </div>
                  <campaign-item *ngFor="let campaign of historiesCampaignList"
                    [campaign]="campaign"
                    [isCampaignHistory]="isCampaignHistory"
                    [enableInfluencerPlatform]="enableInfluencerPlatform"
                    (eventSelectCampaign)="onSelectCampaign($event)"
                    (eventDeleteCampaign)="showWarningDeleteCampaignPopup($event)"
                    (eventOpenAddInfluencer)="openAddInfluencer($event)"
                    (eventOpenMeasurePage)="openMeasurePage($event)"
                    (goToCampaignDetails)="goToCampaignDetails(campaign.id)">
                  </campaign-item>
                </div>
              </ng-container>
            </ng-container>
          </achoo-placeholder>
        </div>
        <div *ngIf="!isCampaignHistory && !enableInfluencerPlatform" class="vertical-seperator"></div>
        <div class="campaign-history-button">
          <button *ngIf="!isCampaignHistory && !enableInfluencerPlatform" class="button gray" (click)="goToCampaignHistory()">{{'campaigns.campaign_history' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bottombar" [ngClass]="{'open': isOpenBottomBar}" *ngIf="!enableInfluencerPlatform">
  <div class="d-flex flex-row full-height">
    <div class="d-flex flex-g4" *ngIf="!isShowAddInfluencerToCampaignsFragment && !isShowAddInfluencerManuallyFragment">
      <div class="campaign-title-bottom" *ngIf="currentCampaign != null && currentCampaign.name">Campaign: {{currentCampaign.name}}</div>
    </div>
    <div class="d-flex flex-g8" *ngIf="!isShowAddInfluencerToCampaignsFragment && !isShowAddInfluencerManuallyFragment">
      <div class="buttons d-flex flex-row flex-auto justify-content-end" *ngIf="currentCampaign !== null && !isCampaignHistory">
        <button class="button gray" (click)="openMeasurePage(currentCampaign)">{{'common.btn.open_report' | translate}}</button>
        <button class="button red" (click)="showWarningDeleteCampaignPopup(currentCampaign)">{{'common.btn.delete' | translate}}</button>
        <button class="button blue" (click)="showAddInfluencerToCampaigns()">{{'common.btn.add_to_compaign' | translate}}</button>
        <button class="button green" (click)="editSelectedCampaign($event)">{{'common.btn.edit_campaign' | translate}}</button>
      </div>

      <div class="buttons d-flex flex-auto justify-content-end" *ngIf="currentCampaign === null && !isCampaignHistory">
        <button class="button green create-campaign" (click)="newCampaign($event)">{{'common.btn.new_campaign' | translate}}</button>
      </div>
      <div class="buttons d-flex flex-auto justify-content-end" *ngIf="isCampaignHistory">
        <button class="button red" (click)="backToCampaignPage()">{{'common.btn.back' | translate}}</button>
      </div>
    </div>
    <div class="d-flex flex-g1" *ngIf="isShowAddInfluencerToCampaignsFragment">
      <add-influencer-campaign class="d-flex flex-auto"
                               [platformList]="platformList"
                               [campaign]="currentCampaign"
                               [initializeInfluencerList]="pendingInfluencerListAddToCampaign"
                               [isShowAddInfluencerToCampaignsFragment]="isShowAddInfluencerToCampaignsFragment"
                               [alreadySelectedInfluencers]="selectedInfluencerToAddCampaign"
                               [addInfluencerAsAccepted]="addInfluencerAsAccepted"
                               (closeFragmentEvent)="closeAddInfluencerToCampaign($event)"
                               (addNewInfluencerManuallyEvent)="showFragmentAddInfluencerManually($event)"
                               (eventAddInfluencerToCampaigns)="addInfluencerToCampign($event)">
      </add-influencer-campaign>
    </div>
    <div class="d-flex flex-g1" *ngIf="isShowAddInfluencerManuallyFragment">
      <add-influencer-manually (closeFragmentAddInfluencerManually)="closeFragmentAddInfluencerManually($event)"
                               [influencerSuggestion]="processingInfluencerSuggestion">
      </add-influencer-manually>
    </div>
  </div>
</div>

<achoo-popup #WarningCampaignDialog
             [isAlertPopup]="true"
             [acceptBtnLabel]="acceptBtnLabel"
             [cancelBtnLabel]="acceptCancelLabel"
             (acceptCallback)="acceptToDeleteCampaign()"
             (cancelCallback)="closeWarningDeleteICampaignPopup()">
  <span [innerHTML]="warningDeleteCampaignMessage"></span>
</achoo-popup>
<achoo-popup #AlertErrorWhenAddInfluencerToCampaign
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <div class="d-flex flex-column flex-auto">
    <span>
      {{errorMessage}}
    </span>
  </div>
</achoo-popup>
<achoo-popup #SearchCampaignErrorDialog
             [isAlertPopup]="true"
             [acceptBtnLabel]="'common.btn.retry' | translate"
             [cancelBtnLabel]="'common.btn.cancel' | translate"
             (acceptCallback)="onRetrySearch()"
             (cancelCallback)="onCancelSearch()">
  <span>{{errorMessage}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaigns.component.html